import { IconProps } from './index';

const ExclamationCircleLine: React.VFC<IconProps> = ({ title, titleId, ...props }) => {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path
                d="M7 13.667A6.667 6.667 0 117 .333a6.667 6.667 0 010 13.334zm0-1.334A5.334 5.334 0 107 1.666a5.334 5.334 0 000 10.667zM6.333 9h1.334v1.333H6.334V9zm0-5.333h1.334v4H6.334v-4z"
                fill="currentColor"
            />
        </svg>
    );
};

export default ExclamationCircleLine;
